/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import { BannerPropTypes } from '../../Banner';
import BannerSliderWrapper from '../../components/BannerSliderWrapper';
import StepsWrapper from '../../components/StepsWrapper';

const BannerDefault = ({ sliderData, isMobile }) => {
  const [bar, changeActiveSteps] = useState({ steps: [], url: '' });

  const slideChange = num => {
    changeActiveSteps(prevState => ({ ...prevState, steps: sliderData[num].steps, url: sliderData[num].url }));
  };

  const sliderFooter = <StepsWrapper bar={bar} />;

  return (
    <BannerSliderWrapper
      sliderData={sliderData}
      key="slider-wrapper"
      isMobile={isMobile}
      sliderFooter={sliderFooter}
      slideChange={slideChange}
    />
  );
};

BannerDefault.propTypes = {
  ...BannerPropTypes,
};

export default BannerDefault;
